import { useEffect, useMemo, useRef, useState } from "react";

import { Box, Button, Card, Collapse, Fade, Grid, IconButton, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";

import { LAYOUT_MARGIN } from "Configs/home";
import { OperationNames } from "Types/operation";

import useCancelOperation from "Hooks/useCancelOperation";
import { useAppDispatch, useAppSelector } from "Hooks/useRedux";
import useWindowSize from "Hooks/useWindowSize";

import { changeModal } from "Redux/modalSlice";
import { setMinimize } from "Redux/mapSlice";
import { deselectStation, setStations, selectStationStar } from "Redux/stationsSlice";
import { ReactSortable } from "react-sortablejs";
import { IStation } from "Types/station";

const draggableList = [
  {
    id: 1,
    name: "زون ها",
  },
  {
    id: 2,
    name: "ایستگاه ها",
  },
  {
    id: 3,
    name: "مسیر ها",
  },
  {
    id: 4,
    name: "تقاضای سفر",
  },
];

interface ItemType {
  id: number;
  name: string;
}

// Doesn't look good but it works :(
const SIZES: { [key: string]: number } = {
  operationBoxHeight: 56,
  marginTop: 8,
  toolsBoxHeight: 56,
  marginBottom: 8,
  topContent: 70,
  bottomContent: 56,
  bottomContentMargin: 16,
  toolsBoxPadding: 8,
};

export default function SortStations() {
  const dispatch = useAppDispatch();
  const { name } = useAppSelector((state) => state.operation);
  const { path } = useAppSelector((state) => state.app);
  const { stations, starStation, visibleStationDashboard } = useAppSelector((state) => state.stations);
  const [list, setList] = useState<IStation[]>([...stations]);

  useEffect(() => {
    setList([...stations]);
  }, [stations]);

  const { height } = useWindowSize();

  const { cancelOperation } = useCancelOperation();

  const [isOpen, setIsOpen] = useState<boolean>(true);

  const operationNames: OperationNames[] = ["create-path", "edit-path"];
  const isActive = name !== null && operationNames.includes(name);

  const toggleCollapse = () => setIsOpen((prev) => !prev);

  const boxHeight = useMemo(() => {
    let result = 0;
    Object.keys(SIZES).forEach((key) => {
      result += SIZES[key];
    });
    return `${height - (result + LAYOUT_MARGIN * 2 + 56 + 16)}px`;
  }, [height]);

  const handleSelectedStation = (station: any) => {
    if (starStation.id === station.id) {
      dispatch(selectStationStar({ starStation: {}, visible: false }));
    } else {
      dispatch(selectStationStar({ starStation: station, visible: true }));
    }
  };

  const renderStations = useMemo(() => {
    return (
      <>
        {/* {stations.map((station, index) => {
          console.log(station, "st83");
          return (
            <Grid container mb={1} alignItems="center" columnSpacing={0.5}>
              <Grid item xs={1.5}>
                <Typography align="center" className="fa-number">
                  {index + 1}
                </Typography>
              </Grid>
              <Grid item xs={9}>
                <Box sx={{ border: "1px solid #aaa", p: 1.5, borderRadius: 1 }}>
                  <Typography color="common.black" fontWeight="600">
                    {station.title}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={1.5}>
                <IconButton onClick={() => dispatch(deselectStation(station.id))}>
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Grid>
            </Grid>
          );
        })} */}
        {/* {stations?.length > 0 ? ( */}
        <ReactSortable
          onStart={(e) => {}}
          filter=".addImageButtonContainer"
          dragClass="sortableDrag"
          list={stations.map((x) => ({ ...x, chosen: true }))}
          setList={(currentList) => {
            dispatch(setStations(currentList));
          }}
          animation={200}
          easing="ease-out"
          style={{ display: "flex", flexDirection: "column" }}
        >
          {stations.map((station, index) => (
            // <div className="draggableItem">{item.title}</div>
            <Grid container mb={1} alignItems="center" columnSpacing={0.5} sx={{ cursor: "pointer" }}>
              <Grid item xs={1.5}>
                <Typography align="center" className="fa-number">
                  {index + 1}
                </Typography>
              </Grid>
              <Grid item xs={9}>
                <Button
                  sx={{ display: "block", width: "100%", padding: "0", textAlign: "left" }}
                  onClick={() => handleSelectedStation(station)}
                >
                  <Box
                    sx={{
                      backgroundColor: starStation.id === station.id ? "rgb(0, 160, 128,0.2)" : "",
                      border: "1px solid #aaa",
                      p: 1.5,
                      borderRadius: 1,
                    }}
                  >
                    <Grid container mb={1} alignItems="center" columnSpacing={0.5} sx={{ justifyContent: "space-between" }}>
                      <Grid item xs={8.5}>
                        <Typography
                          color="common.black"
                          fontWeight="600"
                          sx={{ opacity: 1, textOverflow: "ellipsis", overflow: "hidden" }}
                        >
                          {station.title}
                        </Typography>
                      </Grid>

                      <Grid item xs={3}>
                        <Typography
                          color="common.black"
                          fontWeight="600"
                          sx={{ opacity: 1, textOverflow: "ellipsis", overflow: "hidden", color: "#484242" }}
                        >
                          {station.code}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Box>
                </Button>
              </Grid>
              <Grid item xs={1.5}>
                <IconButton onClick={() => dispatch(deselectStation(station.id))}>
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Grid>
            </Grid>
          ))}
        </ReactSortable>
        {/* ) : null} */}
      </>
    );
  }, [stations, dispatch, starStation]);
  return (
    <Fade in={isActive} mountOnEnter unmountOnExit>
      <Card sx={{ mt: 1, p: 2, width: "100%", boxShadow: 3 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography fontWeight="800"> {path?.name}</Typography>

          <Button
            startIcon={<KeyboardDoubleArrowDownIcon sx={{ transform: isOpen ? "rotate(180deg)" : "", transition: "all 0.3s" }} />}
            sx={{ minWidth: "100px" }}
            onClick={toggleCollapse}
          >
            {isOpen ? "بستن" : "بازکردن"}
          </Button>
        </Stack>

        <Collapse in={isOpen}>
          <Box sx={{ height: boxHeight, py: 2, overflowY: "scroll" }}>
            {stations.length === 0 ? <Typography align="center">ایستگاهی انتخاب نشده است</Typography> : renderStations}
          </Box>
          <Stack direction="row" spacing={1} mt={2}>
            <Button fullWidth size="large" variant="light" onClick={cancelOperation}>
              انصراف
            </Button>
            <Button
              fullWidth
              size="large"
              variant="contained"
              onClick={() => {
                dispatch(changeModal({ status: "create-path" }));
              }}
            >
              {name === "create-path" ? "ثبت" : "ویرایش"} مسیر
            </Button>
          </Stack>
        </Collapse>
      </Card>
    </Fade>
  );
}
